import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=d068cac4"
import script from "./DashboardMenu.vue?vue&type=script&lang=js"
export * from "./DashboardMenu.vue?vue&type=script&lang=js"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=d068cac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports